import React from 'react';
import { PreAuthentificationPage } from './preAuthentificationPage';

export function ContactSystemAdminScreen(): JSX.Element {
  return (
    <PreAuthentificationPage
      header="You don't have permissions."
      paragraph="Please contact your system administrator to request access to the application."
    />
  );
}
